<template>
  <emh-footnote-reference
    :text.attr="text"
    :context.attr="context"
    :reference.attr="reference"
    :force-pilot.attr="showPilot"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { isFootnotePilot } from '../../utils/footnote.util';

export default defineComponent({
  name: 'FootnoteReference',
  props: {
    text: {
      type: String,
      required: true,
    },
    context: {
      type: String,
      default: 'default',
    },
    reference: {
      type: String,
      required: false,
      default: undefined,
    },
    forcePilot: {
      type: Boolean,
      required: false,
      default: undefined,
    },
  },
  setup(props) {
    const showPilot = props.forcePilot !== undefined ? props.forcePilot : isFootnotePilot();

    return {
      showPilot,
    };
  },
});
</script>
